<template>
  <div class="fade-in">
    <h1 class="title">Create an Interview</h1>

    <interview-form
      :model="interview"
      :loading="loading"
      :onSubmit="onSubmit"
      submitText="Create"
    ></interview-form>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import InterviewsService from "@/services/InterviewsService";
import InterviewForm from "./InterviewForm";

export default {
  name: "interview-create",

  components: {
    VueToastr,
    InterviewForm
  },

  data() {
    return {
      loading: false,
      taggingSelected: [],
      taggingOptions: [],
      interview: {
        name: "",
        kind: 0,
        tagList: []
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      this.interview.tagList = this.interview.tagList.map(o => o.label);
      InterviewsService.create(this.interview)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "interview-pool" });
          this.$refs.toastr.s("The interview has been created.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error creating the interview.");
        });
    }
  }
};
</script>

<style lang="scss"></style>
